<template>
<div class="contact-bg">
 <div class="container">
   <div class="row">
    <h1 class="text-center main-title" v-html="$t('title.contact')">
      联系<em>我们</em>
      <span>contact</span>
    </h1>
    <dl class="col-md-12">
      <dt class="text-center" style="font-size:16px;">{{$t('contact.name')}}</dt>
      <dd class="col-sm-6 col-md-4">{{$t('contact.address')}}{{msg[5].values}} </dd>
      <dd class="col-sm-6 col-md-4">{{$t('contact.hotline')}}{{msg[0].values}}</dd>
      <dd class="col-sm-6 col-md-4">{{$t('contact.zipcode')}}{{msg[3].values}}  </dd>
      <dd class="col-sm-6 col-md-4">{{$t('contact.fax')}}{{msg[2].values}}</dd>
      <dd class="col-sm-6 col-md-4">{{$t('contact.cellphone')}}{{msg[1].values}}</dd>
      <dd class="col-sm-6 col-md-4">{{$t('contact.mailbox')}}{{msg[4].values}}</dd>
    </dl>
    <div >
      
      <iframe frameborder="0" height="600" marginheight="0" marginwidth="0" scrolling="no" src="
http://api.map.baidu.com/marker?location=30.910345,120.014682&amp;title=湖州璟宝新型建材有限公司&amp;content=地址：浙江省湖州市杨家埠果木园路118号&amp;output=html&amp;src=yourComponyName|yourAppName" width=100% class="mt20"></iframe>
    </div>
   </div>
  
  </div>
</div>
 
</template>

<script>
export default {
  name: 'Contact',
  metaInfo() {
    return {
      title: this.pageName
    }; // set a title
  },
      
  data () {
    return {
      msg: ''
    }
  },
  mounted(){
    this.$http
      .get("http://www.hzjingbao.cn/api/contact", {
        params: {
          lang: this.$i18n.locale,
        }
      })
      .then(res => {
      //  console.log(res.data);
        this.msg=res.data

       // console.log(this.productdata.length);
      })
      .catch(erroe => {
        console.log(error);
      })
  },
  computed:{
    pageName(){
      return this.$t("nav[4].name");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/contact.vue